import * as React from "react";
const SvgLine = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 50 2",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeWidth: 2,
	d: "M.427 1H49.65"
}));
export default SvgLine;
